import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Chip,
  Box,
  Stack,
  Typography,
} from '@mui/material';

export default function SelectBuyerOrdersDialog({
  open,
  onClose,
  orders = [],
  selected = [],
  onConfirm,
  title = 'Selecciona Órdenes de Compra',
}) {
  const [selectedOrders, setSelectedOrders] = React.useState(selected);

  React.useEffect(() => {
    setSelectedOrders(selected);
  }, [selected, open]);

  const handleConfirm = () => {
    onConfirm(selectedOrders);
    onClose();
  };

  const handleRemove = (id) => {
    setSelectedOrders((prev) => prev.filter((o) => o.id !== id));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={orders.filter((o) => !selectedOrders.find((sel) => sel.id === o.id))}
          getOptionLabel={(option) => option.nombre || option.name || `Orden #${option.numero || option.numero_orden}`}
          value={[]}
          onChange={(_, value) => {
            // Agrega los seleccionados
            setSelectedOrders((prev) => [...prev, ...value]);
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Buscar..." fullWidth/>
          )}
        />
        <Box mt={2} px={2}>
          <Typography variant="subtitle2" gutterBottom>
            Órdenes seleccionadas:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {selectedOrders.length === 0 && (
              <Typography color="text.secondary">Ninguna seleccionada</Typography>
            )}
            {selectedOrders.map((order) => (
              <Chip
                key={order.id}
                label={order.nombre || order.name || `Orden #${order.numero || order.numero_orden}`}
                onDelete={() => handleRemove(order.id)}
                sx={{ mb: 1 }}
              />
            ))}
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined' >Cancelar</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={selectedOrders.length === 0} color='primarybutton' sx={{fontWeight:"bold"}}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
